export default __webpack_public_path__ + "static/media/shirt13.14f28afd.jpeg";